import {
  NotaryProduct,
  NotaryProductResource,
  Step
} from '@ligo/bv-flow/store';
import { ApiService } from '@ligo/shared/utils';
import { TransferOfSharesResource } from './definitions/transfer_of_shares';
import { useMainResource } from './resources/main';
import { shareholderResources } from './resources/shareholders';
import { paymentResource, ShareholderType } from '../../share';
import { getSteps } from '../../tools';
import { acceptShareholder, NotaryProductSlug } from '../../product_structure';

const steps: Array<Step> = [
  {
    name: 'transfer_of_shares.company_name.name',
    completed: false
  },
  {
    name: 'transfer_of_shares.shareholder_information.name',
    parts: 2,
    currentPart: 0,
    completed: false
  },
  {
    name: 'transfer_of_shares.holding_upsell.name',
    parts: 2,
    currentPart: 0,
    completed: false
  },
  {
    name: 'transfer_of_shares.preview_documents.name',
    completed: false
  }
];
interface TransferOfSharesAPIResponse {
  product_data: TransferOfSharesResource;
  upsell_package: any;
}

const url = 'transfer_of_shares/';
const path = 'transfer_of_shares';
const locale = 'transfer_of_shares';
const typeId = 2;
const slug = NotaryProductSlug.TRANSFER_OF_SHARES;
const finalStep = 4;

const SHAREHOLDER_PREFIX = 'p';
const SHAREHOLDER_NAME_LENGTH = 2;

const saveToAPI = async (product: NotaryProduct, sendStep = true) => {
  const data = product.resources['main'].fieldData();
  // If there is a resource with a 2 letter name that start's with a p, this will assume it's a shareholder
  Object.keys(product.resources).forEach((x) => {
    if (
      x.length == SHAREHOLDER_NAME_LENGTH &&
      x.startsWith(SHAREHOLDER_PREFIX) &&
      acceptShareholder(product.resources[x])
    ) {
      data[x] = product.resources[x].fieldData();
    }
  });
  const nextStep = sendStep ? product.getStepIncrement() : 0;
  data['step'] = product.step + nextStep;
  data['temporal_step'] = product.temporalStep + nextStep;
  data['substep'] = product.substep;
  const request = product.url + product.uuid;
  console.log('PayLoad', data);
  try {
    await ApiService.patch(request, data);
  } catch (error) {
    console.log('PATCH ERROR', error);
  }
};

const loadFromAPI = async (product: NotaryProduct) => {
  if (product.uuid) {
    const response = await ApiService.get<TransferOfSharesAPIResponse>(
      product.url + product.uuid
    );
    console.log('GET', response);
    product.upsellPackageData = response.data.upsell_package;
    const { step, temporalStep, substep } = getSteps(
      product.uuid,
      response.data.product_data
    );
    product.step = step;
    product.temporalStep = temporalStep;
    product.substep = substep;
    product.updateFromJSON(response.data);
  }
};

export const useBV = (uuid?: string) => {
  const resources = {
    ...useMainResource(),
    ...shareholderResources(),
    ...paymentResource(locale)
  };

  return new NotaryProduct(
    resources,
    locale,
    url,
    path,
    saveToAPI,
    loadFromAPI,
    'transfer_of_shares-handler',
    steps,
    typeId,
    slug,
    finalStep,
    uuid,
    false
  );
};
